import styled from "styled-components";

export const FlexContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 70vh;
`;

export const Title = styled.p`
  font-size: 18px;
  color: #030d69;
`;
